/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2019-12-31 10:26:15
 * @modify date 2019-12-31 10:26:15
 * @desc [description]
 */

import $ from 'jquery';
import axios from 'axios';

/**
 * consultant post API
* to add new consultant */
export async function addConsultant(data) {
  let res = {};
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/consultant`, data).then((response) => {
    res = response.data;
  }).catch((err) => {
    console.log('add consultant java api error', err); // eslint-disable-line no-console
  });
  return res;
}
/**
 * consultant list get API
* to get the list of consultants */
export async function getConsultantList() {
  let list = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/consultant`).then((response) => {
    if (response && response.data) list = response.data;
  }).catch((err) => {
    console.log('get consultant list java api error', err); // eslint-disable-line no-console
  });
  return list;
}
/**
 * consultant delete API
* to remove the consultant */
export async function removeConsultant(list) {
  let res = {};
  await axios.delete(`${process.env.VUE_APP_JAVA_API_URL}/consultant`, {
    data: {
      user_account_id: list,
    },
  }).then((response) => {
    res = response.data;
  }).catch((err) => {
    console.log('remove consultant java api error', err); // eslint-disable-line no-console
  });
  return res;
}
/**
 * banner post API
* to add new banner */
export async function getActiveSBAccountsList() {
  let list = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/plan/active/3`).then((response) => {
    if (response.data && response.data.status_code === 200) list = response.data.data;
  }).catch((err) => {
    console.log('/plan/active submission builder java api error', err); // eslint-disable-line no-console
  });
  return list;
}

/**
 * project_manager post API
* to add new project_manager */
export async function addProjectManager(data) {
  let res = {};
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/project_manager`, data).then((response) => {
    res = response.data;
  }).catch((err) => {
    console.log('add project_manager java api error', err); // eslint-disable-line no-console
  });
  return res;
}
/**
 * project_manager get all API
* to get the list of project_managers */
export async function getProjectManagersList() {
  let list = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/project_manager`).then((response) => {
    if (response && response.data) list = response.data;
  }).catch((err) => {
    console.log('get project_manager list java api error', err); // eslint-disable-line no-console
  });
  return list;
}
/**
 * project_manager delete API
* to remove the project_manager */
export async function removeProjectManager(list) {
  let res = {};
  await axios.delete(`${process.env.VUE_APP_JAVA_API_URL}/project_manager`, {
    data: {
      user_account_id: list,
    },
  }).then((response) => {
    res = response.data;
  }).catch((err) => {
    console.log('remove project_manager java api error', err); // eslint-disable-line no-console
  });
  return res;
}

export async function SBLogin(token) {
  let returnData = null;
  await $.ajax({
    url: `${process.env.VUE_APP_RS_URL}/api/login`,
    xhrFields: {
      withCredentials: true,
    },
    type: 'POST',
    async: true,
    data: {
      nextUrl: '/dashboard/api/home',
      token,
      serviceType: 'smartBuilder',
    },
    error(data) {
      returnData = data;
    },
    success(data) {
      returnData = data;
    },
  });
  return returnData;
}

export async function getAccountsList(accountName) {
  let res = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/accounts/${accountName}`)
    .then((response) => {
      res = response.data.data;
    }).catch((err) => {
      console.log('getAccountsList get api failed', err); // eslint-disable-line no-console
    });
  return res;
}

export async function getUsersList(data) {
  let res = [];
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/user`,data)
    .then((response) => {
      res = response.data.data;
    }).catch((err) => {
      console.log('getUsersList post api failed', err); // eslint-disable-line no-console
    });
  return res;
}

export async function getSBExpiringProjects(accountId) {
  let res = [];
  await axios.get(`${process.env.VUE_APP_RS_URL}/get-expired-projects/${accountId}`)
    .then((response) => {
      if (response.status === 200 && response.data.data.length) { res = response.data.data; }
    }).catch((err) => {
      console.log('get SB Projects list failed', err); // eslint-disable-line no-console
    });
  return res;
}

export async function submitSBRenewalRequest(data) {
  let res = '';
  await axios.post(`${process.env.VUE_APP_RS_URL}/renewal-notification`, data)
    .then((response) => {
      res = response.data;
    }).catch((err) => {
      console.log('post SB renewal request failed', err); // eslint-disable-line no-console
    });
  return res;
}
